import { Component, OnInit } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import { filter } from 'rxjs/operators';
import {BrandThemeService} from './shared/brand-theme.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Marketplace';

  constructor(private router: Router,
              private brandThemeService: BrandThemeService) {}

  ngOnInit() {
    this.brandThemeService.ensureLoaded().subscribe();

    // Check if we're at the root URL and redirect to home
    if (window.location.pathname === '/' || window.location.pathname === '') {
      this.router.navigate(['/']);
    }

    // Listen for navigation events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // If we ever end up at the root URL, redirect to home
      if (event.url === '/' || event.url === '') {
        this.router.navigate(['/']);
      }
    });
  }
}
